import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from "@angular/forms";
import { map, Observable, startWith } from "rxjs";
import { DynamicFormModel } from "../../models/dynamic-form-model";

@Component({
  selector: 'ebw-monorepo-dynamic-select',
  templateUrl: './dynamic-select.component.html',
  styleUrls: ['./dynamic-select.component.scss']
})
export class DynamicSelectComponent implements OnInit {
  @Input() field: DynamicFormModel;
  formName: FormGroup;
  selectOptions: string[] = [];
  filteredOptions: Observable<string[]>;
  dropdownMinHeight;
  constructor(private formgroupDirective: FormGroupDirective) {
    this.formName = formgroupDirective.control;
  }

  ngOnInit() {
    this.mapFieldOptionsIntoSelectOptions();
    this.filteredOptions = this.formName.controls[this.field.filterKey].valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value)),
    );

    if (!this.field.autoComplete) {
      const itemSize = ((this.field.options.length + 1) * 42);
      this.dropdownMinHeight = (itemSize <= 200) ? `${itemSize}px` : '200px'
    }
  }


  private mapFieldOptionsIntoSelectOptions() {
    if (this.field.autoComplete) {
      this.field.options
        .filter(
          ({ label, value }) =>
            (label && label !== '') || (value && value !== '')
        )
        .map(({ label, value }) => this.selectOptions.push(label || value));
    }
  }
  private _filter(value: string) {
    const filterValue = (value) ? value.toString().toUpperCase() : null;
    return this.selectOptions.filter((option) => option.toUpperCase().includes(filterValue));
  }
}

